import React, { useEffect, useState } from 'react';
import { FileUploader } from 'react-drag-drop-files';
import Loader from 'react-loader-spinner';
import 'react-loader-spinner/dist/loader/css/react-spinner-loader.css';
import * as api from '../../api/api';

// import { checkDocumentFileName } from "../../api/api";
import { checkFileExtension } from '../Helpers/Constants';
const AWS = require('aws-sdk');
const fileTypes = ['JPG', 'PNG', 'GIF', 'PDF'];

AWS.config.update({
	// accessKeyId: process.env.REACT_APP_AWS_ACCESS_KEY_ID,
	// secretAccessKey: process.env.REACT_APP_AWS_SECRET_ACCESS_KEY,
	region: process.env.REACT_APP_AWS_REGION,
});

export default function App({
	handleSetAttachment,
	handleResetAttachment,
	upLoadingStatus,
	updateAttachment,
	showAlert,
}) {
	const [file, setFile] = useState('');
	const [attachLink, setAttachLink] = useState('');
	const [loader, setLoader] = useState(false);
	const [updateFileName, setUpdateFileName] = useState('');

	useEffect(() => {
		if (updateAttachment) {
			if (updateAttachment.file_name) {
				setFile(updateAttachment);
				setUpdateFileName(updateAttachment.file_name);
			}
		}
	}, []);

	useEffect(() => {
		if (updateAttachment) {
			if (updateAttachment.file_name) {
				setFile(updateAttachment);
				setUpdateFileName(updateAttachment.file_name);
			}
		}
	}, [updateAttachment]);

	const uploadToS3 = async (attachment) => {
		upLoadingStatus(true);
		setLoader(true);

		const formData = new FormData();
		formData.append('file', attachment);
		formData.append('documentType', 'attachment'); // update as needed

		try {
			const response = await api.addDocuments(formData);
			const { status, data } = response;

			if (status !== 200) {
				showAlert('Upload failed or file already exists.');
				handleSetAttachment(null, null, null);
			} else {
				let documentSize = parseFloat(attachment.size / (1024 * 1024)).toFixed(
					2
				);
				handleSetAttachment(attachment.name, data.documentLink, documentSize);
				setAttachLink(data.documentLink);
			}
		} catch (err) {
			console.error('Upload error:', err);
			handleSetAttachment(null, null, null);
			showAlert('Something went wrong');
		}

		setLoader(false);
		upLoadingStatus(false);
	};

	const handleRomoveAttachment = () => {
		setFile('');
		setUpdateFileName(null);
		handleResetAttachment();
	};
	const handleChangeFileUpload = async (attachment) => {
		let { allow, type } = await checkFileExtension(attachment);
		if (allow) {
			const {
				data: { allowed, message },
			} = await api.checkDocumentFileName({ filename: attachment.name });
			if (allowed) {
				setFile(attachment);
				uploadToS3(attachment, type);
			} else {
				showAlert(message);
			}
		} else {
			showAlert('File type not allowed');
		}
	};
	return (
		<div className='App'>
			<FileUploader
				multiple={false}
				label='Upload or drop a file right here'
				handleChange={handleChangeFileUpload}
				name='file'
				types={fileTypes}
				fileOrFiles={file}
			/>
			<div
				style={{
					display: 'flex',
					flexDirection: 'row',
					justifyContent: 'space-between',
					alignItems: 'center',
					marginTop: 5,
				}}
			>
				{updateFileName ? (
					<a
						href={updateAttachment.attachLink}
					>{`File name: ${updateFileName}`}</a>
				) : (
					<a href={attachLink != '' ? attachLink : null}>
						{file && file != ''
							? `File name: ${file?.name}`
							: 'No file uploaded yet'}
					</a>
				)}
				{file && (file != '') & !loader ? (
					<button
						onClick={handleRomoveAttachment}
						style={{
							backgroundColor: 'lightgray',
							borderRadius: 20,
							height: 20,
							width: 20,
							border: 'none',
							display: 'flex',
							justifyContent: 'center',
							alignItems: 'center',
						}}
					>
						<p style={{ color: 'black', fontStyle: 'bold', fontSize: 15 }}>x</p>
					</button>
				) : loader ? (
					<div className='loader-cont'>
						{' '}
						<p style={{ fontSize: 11, paddingRight: 3 }}>uploading file...</p>
						<Loader type='Oval' color='black' height={20} width={20} />
					</div>
				) : null}
			</div>
		</div>
	);
}
